import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { NbAccessChecker } from '@nebular/security';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Injectable()
export class AuthorizationGuard  {
  constructor(private accessChecker: NbAccessChecker, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._checkActivation(route, state);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._checkActivation(route, state);
  }

  private _checkActivation(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    let permission = 'view';
    let resource: string = state.url.split('/')[1];

    if (route.data.permission !== undefined) {
      permission = route.data.permission;
    }
    if (route.data.resource !== undefined) {
      resource = route.data.resource;
    }

    if (!resource) {
      throw new Error('AuthGuard: resource not found');
    }

    return this.accessChecker.isGranted(permission, resource).pipe(
      tap((authorized) => {
        if (!authorized) {
          this.router.navigate(['not-authorized']);
        }
      }),
      take(1)
    );
  }
}
